import { render, staticRenderFns } from "./systemConfig.vue?vue&type=template&id=66467415&scoped=true"
import script from "./systemConfig.vue?vue&type=script&lang=js"
export * from "./systemConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66467415",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66467415')) {
      api.createRecord('66467415', component.options)
    } else {
      api.reload('66467415', component.options)
    }
    module.hot.accept("./systemConfig.vue?vue&type=template&id=66467415&scoped=true", function () {
      api.rerender('66467415', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wx/systemConfig.vue"
export default component.exports